import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-home",
  "use": "icon-home-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-home\"><path d=\"M916 907.2c0 27-21.9 48.8-48.8 48.8h-710c-27 0-48.8-21.9-48.8-48.8V459.3c0-0.9 0-1.7 0.1-2.6-2.4-20.5 4.7-41.8 21.4-57.5L459.2 88.6c29.1-27.5 76.3-27.5 105.4 0L894 399.2c15.8 14.9 23 34.8 21.7 54.3 0.2 1.9 0.4 3.9 0.4 5.8v447.9zM640.9 741.5c0-63.8-53.9-115.5-120.4-115.5s-120.4 51.7-120.4 115.5V956h240.7V741.5z\" p-id=\"13837\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol